import { render, staticRenderFns } from "./CompanyComponent.vue?vue&type=template&id=33eca907&scoped=true"
import script from "./CompanyComponent.vue?vue&type=script&lang=js"
export * from "./CompanyComponent.vue?vue&type=script&lang=js"
import style0 from "./CompanyComponent.vue?vue&type=style&index=0&id=33eca907&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eca907",
  null
  
)

export default component.exports